import React, { useCallback } from 'react'
import MaUTable from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TablePaginationActions from './TablePaginationActions'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TableToolbar from './TableToolbar'
import { useGlobalFilter, usePagination, useRowSelect, useSortBy, useTable, Column, useFilters, TableState, IdType, Row,} from 'react-table'
import { Box, makeStyles, Paper, TableFooter, TextField, Theme } from '@material-ui/core'
//import DefaultColumnFilter from './ColumnFilter'

const useStyles = makeStyles((theme: Theme) => ({
  table: {
  },
  con: {
    [theme.breakpoints.down('xs')]: {
      maxWidth: '90vw',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90vw',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '90vw',
    },
    [theme.breakpoints.down('lg')]: {
      maxWidth: '90vw',
    },
    overflowX: "auto",
  },

  tableRow: {
    "&:hover": {
      cursor: "pointer"
    }
  },

  headerRow: {
    //minWidth: 100,
    //maxWidth: 500,
    position: 'sticky',
    background: 'white',
    top: 0,
    zIndex: 5,
    outlineStyle: "solid",
    outlineWidth: "1px",
    outlineColor: "black",
  },

  stickyColumn: {
    position: "sticky",
    left: 0,
    background: "white",
    [theme.breakpoints.down('sm')]: {
      padding: "6px",
      fontSize: "0.6rem",
    }
  },

  tableCell: {
    //minWidth: 100,
    //maxWidth: 500,
    [theme.breakpoints.down('sm')]: {
      padding: "6px",
      fontSize: "0.6rem",
    }
    // [theme.breakpoints.down('sm')]: {
    //   borderBottom: "1px solid #ddd",
    //   display: "block",
    //   fontSize: "1em",
    //   textAlign: "right",
    //   fontWeight: "bold",
    //   marginBottom: "4%",

    //   "&::before": {
    //     content: '"" attr(label) ""',
    //     float: "left",
    //     textTransform: "uppercase",
    //     fontWeight: "normal",
    //     fontSize: ".85em",
    //   }
    // }
  }
}));

interface ITable<T extends object> {
  columns: Column<T>[]
  data: T[]
  initialState: Partial<TableState<T>> | undefined
  clickEvent: (element: T) => void
  update: (() => void) | null
  pending: boolean
  text: string
  customCellStyle?: (columns: Column<T>[], index: number, value: any) => {background: string;}
  columnFilter?: boolean
}

function EnhancedTable<T extends object>({columns,data,initialState,clickEvent,update,pending,text,customCellStyle, columnFilter}: ITable<T> & { children?: React.ReactNode }): React.ReactElement {
  const classes = useStyles();

  const theGlobalFilter = useCallback(
    (rows: Row<T>[], ids: IdType<T>[], query: string) => {
      let examText = query.replace(/([.()[\]|])/g, '\\$1').replaceAll("*", ".*") // This changes "*" to be the same as ".*", which adds the functionality of wildcard searching
      let tempQueary = examText.toLowerCase()
      let dataCopy = rows

      let tempRow = dataCopy.filter(function callbackFn(row: any){
        for (let index = 0; index <  row.cells.length; index ++)
        {

          if (row.values[index] === null){ // removes null, => this avoids web crashes
            return false
          }

          if (typeof row.values[index] === "undefined"){ // removes undefined, => this avoids web crashes
            return false
          }

          if (row.values[index].toString().toLowerCase().match(tempQueary)){ // using REGEX the data is filtered returning each match that correlates to the "tempQueary"
            return true
          }
        }
      })
    return tempRow

    }, [],
  );
  
  const DefaultColumnFilter = useCallback(
    ({column: { filterValue, preFilteredRows, setFilter }}) =>
    {
    const count = preFilteredRows.length;
  
    return (
      <TextField
        inputProps={{
          value: filterValue || "", 
          onChange: (e: any) => {         
            setFilter(e.target.value || undefined); 
          },
          placeholder: "",
        }}
      />
    )}, [],
  );
  
const defaultColumn = React.useMemo(
  () => ({
    Filter: DefaultColumnFilter,
  }),
  []
)

  const {
    getTableProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter, filters },
    //allColumns,
    //getToggleHideAllColumnsProps,
    //setHiddenColumns,
    //filterTypes,
  } = useTable<T>(
    {
      columns,
      data,
      initialState,
      defaultColumn,
      //globalFilter: theGlobalFilter, // this enables wildcard search, globalfilter only works on the current pagnation of pages
      //autoResetPage: !skipPageReset,
      // updateMyData isn't part of the API, but
      // anything we put into these options will
      // automatically be available on the instance.
      // That way we can call this function from our
      // cell renderer!
      // updateMyData,
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect,
    hooks => {
      hooks.allColumns.push(columns => [
        ...columns,
      ])
    }
  )

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    gotoPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPageSize(Number(event.target.value))
  }

  const handleClick = (event: React.MouseEvent<unknown>, name: string, row: any) => {
    clickEvent(row.original)
  };

  // Render table UI
  return (
    <>
    <div>
    <Paper>
    <TableContainer style={{maxHeight: "650px"}} className={classes.con}>
      <TableToolbar
        
        // numSelected={Object.keys(selectedRowIds).length}
        // deleteUserHandler={deleteUserHandler}
        // addUserHandler={addUserHandler}
        preGlobalFilteredRows={preGlobalFilteredRows}
        setGlobalFilter={setGlobalFilter}
        globalFilter={globalFilter}
        update={update}
        pending={pending}
        text={text}
      />
      <MaUTable {...getTableProps()} className={classes.table}>
        <TableHead className={classes.headerRow}>
          {headerGroups.map(headerGroup => (
            <TableRow style={{ verticalAlign: 'top'}} {...headerGroup.getHeaderGroupProps()} >
              {headerGroup.headers.map(column => (
                <TableCell variant='head' {...(column.getHeaderProps())} className={column.id === "0" ? classes.stickyColumn : classes.tableCell}>
                      <Box style={{ whiteSpace: "nowrap"}}>
                        {column.render("Header")}
                        {column.id !== 'selection' 
                          ? (<>
                              <TableSortLabel {...(column.getHeaderProps(column.getSortByToggleProps()))} active={column.isSorted}
                              // react-table has a unsorted state which is not treated here
                              direction={column.isSortedDesc ? 'desc' : 'asc'}/>
                            </>) 
                          : null}
                      </Box>
                      <Box>
                        {column.render("Filter")}
                      </Box>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <TableRow
                {...row.getRowProps()}
                onClick={(event) => handleClick(event, row.id, row)}
                className={classes.tableRow} >
                {row.cells.map((cell, index) => {
                  return (
                    <TableCell
                      label={columns[index].Header?.toString()}
                      {...cell.getCellProps()}

                      // colSpan={headerGroups[0].headers.length}
                      style={
                        (customCellStyle) ? customCellStyle(columns, index, cell.value) : {}
                      }
                      className={columns[index].id === "0" ? classes.stickyColumn : classes.tableCell}
                    >
                      {cell.render('Cell')}
                    </TableCell>
                  )
                })}
              </TableRow>

            )
          })}
        </TableBody>
        {data.length === 0 &&
          <TableFooter>
            <TableRow>
              <TableCell colSpan={headerGroups[0].headers.length} align="center">
                Ingen data
              </TableCell>
            </TableRow>
          </TableFooter>
        }
      </MaUTable>
    </TableContainer>
    <TablePagination
              rowsPerPageOptions={[
                10,
                50,
                150,
                500
                //{ label: 'Alle', value: data.length },
              ]}
              component="div"
              colSpan={3}
              count={data.length}
              rowsPerPage={pageSize}
              page={pageIndex}
              labelRowsPerPage='Rækker per side'
              SelectProps={{
                inputProps: { 'aria-label': 'Rækker per side' },
                //native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
    </Paper >
    </div>
    </>
  )


// import React, { Fragment } from 'react'

// import MaUTable from '@material-ui/core/Table'
// import TableBody from '@material-ui/core/TableBody'
// import TableCell from '@material-ui/core/TableCell'
// import TableContainer from '@material-ui/core/TableContainer'
// import TableHead from '@material-ui/core/TableHead'
// import TablePagination from '@material-ui/core/TablePagination'
// import TablePaginationActions from './TablePaginationActions'
// import TableRow from '@material-ui/core/TableRow'
// import TableSortLabel from '@material-ui/core/TableSortLabel'
// import TableToolbar from './TableToolbar'
// import {
//   useGlobalFilter,
//   usePagination,
//   useRowSelect,
//   useSortBy,
//   useTable,
//   Column,
//   useFilters,
//   TableState,
// } from 'react-table'
// import { makeStyles, Paper, TableFooter, Theme } from '@material-ui/core'

// const useStyles = makeStyles((theme: Theme) => ({
//   table: {
//     //maxWidth: '20rem',
//   },

//   headerRow: {
//     [theme.breakpoints.down('sm')]: {
//       display: 'none',
//     }
//   },

//   tableRow: {
//     [theme.breakpoints.down('sm')]: {
//       borderBottom: "5px solid #ddd",
//       // display: "block",
//     },
//     // "&:hover": {
//     //   cursor: "pointer"
//     // }
//   },

//   tableCell: {
//     // [theme.breakpoints.down('sm')]: {
//     //   borderBottom: "1px solid #ddd",
//     //   display: "block",
//     //   fontSize: "1em",
//     //   textAlign: "right",
//     //   fontWeight: "bold",
//     //   marginBottom: "4%",

//     //   "&::before": {
//     //     content: '"" attr(label) ""',
//     //     float: "left",
//     //     textTransform: "uppercase",
//     //     fontWeight: "normal",
//     //     fontSize: ".85em",
//     //   }
//     // }
//   }
// }));

// interface ITable<T extends object> {
//   columns: Column<T>[]
//   data: T[]
//   initialState: Partial<TableState<T>> | undefined
//   clickEvent: (element: T) => void
//   update: (() => void) | null
//   pending: boolean
//   text: string
//   customCellStyle?: (columns: Column<T>[], index: number, value: any) => {background: string;}
// }

// function EnhancedTable<T extends object>({columns,data,initialState,clickEvent,update,pending,text,customCellStyle}: ITable<T> & { children?: React.ReactNode }): React.ReactElement {
//   const classes = useStyles();

//   const {
//     getTableProps,
//     headerGroups,
//     prepareRow,
//     page,
//     gotoPage,
//     setPageSize,
//     preGlobalFilteredRows,
//     setGlobalFilter,
//     state: { pageIndex, pageSize, globalFilter },
//   } = useTable<T>(
//     {
//       columns,
//       data,
//       initialState,
//       //defaultColumn,
//       //autoResetPage: !skipPageReset,
//       // updateMyData isn't part of the API, but
//       // anything we put into these options will
//       // automatically be available on the instance.
//       // That way we can call this function from our
//       // cell renderer!
//       // updateMyData,
//     },
//     useGlobalFilter,
//     useFilters,
//     useSortBy,
//     usePagination,
//     useRowSelect,
//     hooks => {
//       hooks.allColumns.push(columns => [
//         ...columns,
//       ])
//     }
//   )

//   const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
//     gotoPage(newPage)
//   }

//   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setPageSize(Number(event.target.value))
//   }

//   const handleClick = (event: React.MouseEvent<unknown>, name: string, row: any) => {
//     clickEvent(row.original)
//   };

//   // Render the UI for your table
//   return (
//     <div>
//     <Paper>
//     <TableContainer>
//       <TableToolbar
//         // numSelected={Object.keys(selectedRowIds).length}
//         // deleteUserHandler={deleteUserHandler}
//         // addUserHandler={addUserHandler}
//         preGlobalFilteredRows={preGlobalFilteredRows}
//         setGlobalFilter={setGlobalFilter}
//         globalFilter={globalFilter}
//         update={update}
//         pending={pending}
//         text={text}
//       />
//       <MaUTable {...getTableProps()} className={classes.table}>
//         <TableHead className={classes.headerRow}>
//           {headerGroups.map(headerGroup => (
//             <TableRow {...headerGroup.getHeaderGroupProps()}>
//               {headerGroup.headers.map(column => (
//                 <TableCell
//                   // {...(column.id === 'selection'
//                   //   ? column.getHeaderProps()
//                   //   : column.getHeaderProps(column.getSortByToggleProps()))} //column.getHeaderProps(column.getSortByToggleProps())
//                     {...(column.getHeaderProps(column.getSortByToggleProps()))}
//                 >
//                   {column.render('Header')}
//                   {column.id !== 'selection' ? (
//                     <TableSortLabel
//                       active={column.isSorted}
//                       // react-table has a unsorted state which is not treated here
//                       direction={column.isSortedDesc ? 'desc' : 'asc'}
//                     />
//                   ) : null}
//                 </TableCell>
//               ))}
//             </TableRow>
//           ))}
//         </TableHead>
//         <TableBody>
//           {page.map((row, i) => {
//             prepareRow(row)
//             return (
//               <TableRow
//                 {...row.getRowProps()}
//                 onClick={(event) => handleClick(event, row.id, row)}
//                 className={classes.tableRow}
//               >
//                 <Fragment>
//                   <TableRow>
//                     <TableCell
//                       //colSpan={headerGroups[0].headers.length}
//                       colSpan={5}
//                       label={columns[0].Header?.toString()}
//                       {...row.cells[0].getCellProps()}
//                       // rowSpan={2}
//                       // colSpan={headerGroups[0].headers.length}
//                       style={
//                         (customCellStyle) ? customCellStyle(columns, 0, row.cells[0].value) : {}
//                       }
//                       className={classes.tableCell}
//                       >
//                         {row.cells[0].render('Cell')}
//                     </TableCell>
//                   </TableRow>
//                   <TableRow>
//                     {row.cells.map((cell, index) => {
//                       return (
//                         <Fragment>
//                           {index !== 0 && index !== headerGroups[0].headers.length - 1 &&
//                             <TableCell
//                             label={columns[index].Header?.toString()}
//                             {...cell.getCellProps()}
//                             // rowSpan={2}
//                             // colSpan={headerGroups[0].headers.length}
//                             style={
//                               (customCellStyle) ? customCellStyle(columns, index, cell.value) : {}
//                             }
//                             className={classes.tableCell}
//                             >
//                               {cell.render('Cell')}
//                             </TableCell>
//                           }
//                         </Fragment>


//                       )
//                     })}
//                   </TableRow>

//                 </Fragment>
//               </TableRow>

//             )
//           })}
//         </TableBody>
//         {data.length === 0 &&
//           <TableFooter>
//             <TableRow>
//               <TableCell colSpan={headerGroups[0].headers.length} align="center">
//                 Ingen data
//               </TableCell>
//             </TableRow>
//           </TableFooter>
//         }
//       </MaUTable>
//     </TableContainer>
//     <TablePagination
//               rowsPerPageOptions={[
//                 5,
//                 10,
//                 25,
//                 500
//                 //{ label: 'Alle', value: data.length },
//               ]}
//               component="div"
//               colSpan={3}
//               count={data.length}
//               rowsPerPage={pageSize}
//               page={pageIndex}
//               labelRowsPerPage='Rækker per side'
//               SelectProps={{
//                 inputProps: { 'aria-label': 'Rækker per side' },
//                 //native: true,
//               }}
//               onChangePage={handleChangePage}
//               onChangeRowsPerPage={handleChangeRowsPerPage}
//               ActionsComponent={TablePaginationActions}
//             />
//     </Paper >
//     </div>
//   )
// }
}
export default EnhancedTable;